import { render } from "./NavPlantsSidebarMultiselect.vue?vue&type=template&id=ef0b177e"
import script from "./NavPlantsSidebarMultiselect.vue?vue&type=script&lang=js"
export * from "./NavPlantsSidebarMultiselect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__